// extracted by mini-css-extract-plugin
export default {"cta":"EL0hf39zYmbpvTXfFLdo","icon":"nIgo7u7HoCQrA32GunMX","external":"j9P_YCOwjBIOytqlUCNq"};